import GlobalBackButton from "@/components/GlobalBackButton";
import ObondoClientBillingCard from "@/components/agency/ObondoClientBillingCard";

/**
 * Standalone entry point so a solo trader (not an agency owner) can also
 * "become an API client" and manage their own MAU billing — same backend
 * (`/obondo/mau/my-client`) and same widget as the Agency Dashboard's
 * "API Billing" tab, just reachable without a broker role.
 */
export default function ObondoBillingPage() {
    return (
        <div className="max-w-6xl mx-auto px-4 py-6 space-y-4" data-testid="obondo-billing-page">
            <GlobalBackButton />
            <div>
                <h1 className="text-2xl font-black">Obondo API Billing</h1>
                <p className="text-sm text-muted-foreground">Your Metered Billing Engine profile — MAU usage, cash buffer, tier, and self-service API keys.</p>
            </div>
            <ObondoClientBillingCard />
        </div>
    );
}
